import React, { Fragment } from 'react';
import { Row, Col, Table } from 'reactstrap';


const ClientDealership = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" className='pad-l-r-40 pad-b-0'>
                    <Table>
                        <tbody>
                            <tr>
                                <th>Client Name</th>
                                <td>{data.company?.client_company_name ? data.company?.client_company_name  :  data.brand?.name ? data.brand?.name : '' }</td>
                            </tr>
                            <tr>
                                <th>Dealership Name</th>
                                <td>{data.dealer?.dealer_name}</td>
                            </tr>
                            <tr>
                                <th>Dealership Code</th>
                                <td>{data.dealer?.dealer_code}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};


export default ClientDealership;